import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Share, UserDetail, UserInfo } from '@ca/core/models';
import { UserNotificationService, UserService } from '@ca/core/services';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { FullNameWithEmailPipe } from 'src/app/shared/pipes/full-name-with-email/full-name-with-email.pipe';
import { FullNamePipe } from '../../pipes/full-name/full-name.pipe';

@Component({
    selector: 'ca-share-with-user',
    templateUrl: './share-with-user.component.html',
    styleUrls: ['./share-with-user.component.scss'],
})
export class ShareWithUserComponent {
    @Input() share: Share;
    @Output() save = new EventEmitter<Share>();
    @ViewChild('input') input: ElementRef;

    userToAdd?: UserDetail | null;
    sharesHaveChanged = false;

    get userInfo(): UserInfo | undefined {
        return this.userService.myInfo;
    }

    constructor(
        private fullNamePipe: FullNamePipe,
        private fullNameWithEmailPipe: FullNameWithEmailPipe,
        private userNotificationService: UserNotificationService,
        private userService: UserService,
    ) {
        this.searchUsers$ = this.searchUsers$.bind(this);
    }

    selectUser(event: NgbTypeaheadSelectItemEvent): void {
        const userToAdd = event.item as UserDetail;
        if (this.userInfo?.sub === userToAdd.id) {
            this.userNotificationService.showWarning('MY_WORKSPACE.MY_RESULTS.SHARING.NO_SELF_ADD_POSSIBLE');
            return;
        }

        if (this.share.users.findIndex((userDetail: UserDetail) => userDetail.id === userToAdd.id) === -1) {
            this.share.users.push(userToAdd);
            this.userToAdd = null;
            setTimeout(() => {
                // unfortunately the only way to remove the content of the typeahead
                this.input.nativeElement.value = '';
            });
            this.sharesHaveChanged = true;
        }
    }

    removeUser(user: UserDetail): void {
        const index: number = this.share.users.findIndex(x => x.id === user.id);

        if (index > -1) {
            this.share.users.splice(index, 1);
            this.sharesHaveChanged = true;
        }
    }

    formatUser = (userDetail: UserDetail): string => this.fullNamePipe.transform(userDetail);

    formatUserWithEmail = (userDetail: UserDetail): string => this.fullNameWithEmailPipe.transform(userDetail);

    searchUsers$(text$: Observable<string>): Observable<UserDetail[]> {
        return text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            switchMap(textSearch => (textSearch.length < 2 ? [] : this.userService.searchUsersInfo$(textSearch))),
        );
    }
}
